import styled from 'styled-components';

export const AnnotatedChartContainer = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  /* Column layout so an optional range-lane band can sit above the chart and
     the chart still fills the remaining space (single-child case is unchanged). */
  display: flex;
  flex-direction: column;
`;

export const ChartWrapper = styled.div`
  position: relative;
  width: 100%;
  flex: 1 1 auto;
  min-height: 0;
`;
